import { useEffect, useState } from 'react';

interface UseCountUpOptions {
  start?: number;
  end: number;
  duration?: number;
  delay?: number;
  shouldStart?: boolean;
  /**
   * Casas decimais do número devolvido. Zero (o padrão) serve para contagem
   * de gente e de itens; dinheiro pede 2, senão R$ 356,53 termina em R$ 357,00.
   */
  decimals?: number;
}

export function useCountUp({ 
  start = 0, 
  end, 
  duration = 2000,
  delay = 0,
  shouldStart = true,
  decimals = 0
}: UseCountUpOptions) {
  const [count, setCount] = useState(start);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    if (hasStarted || !shouldStart) return;

    const timeout = setTimeout(() => {
      setHasStarted(true);
      
      const startTime = Date.now();
      const difference = end - start;

      const animate = () => {
        const now = Date.now();
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function (ease-out)
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const current = start + difference * easeOut;

        setCount(current);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCount(end);
        }
      };

      requestAnimationFrame(animate);
    }, delay);

    return () => clearTimeout(timeout);
  }, [start, end, duration, delay, hasStarted, shouldStart]);

  const fator = Math.pow(10, Math.max(0, decimals));
  return Math.round(count * fator) / fator;
}
